import Http from '@/utils/http'
import NLoginApi = global.NLoginApi
import { RequestType } from '@/typings/enum/Common'

class Trial extends Http {
  public async Trial(data: NLoginApi.TrialRequestData) {
    return await super.request<NLoginApi.TrialResponse>({
      url: '/cust/apply',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default Trial
